import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'large' | 'small';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  const sizeClasses = {
    small: 'w-[140px] md:w-[160px]',
    normal: 'w-[160px] md:w-[180px]',
    large: 'w-[180px] md:w-[220px]',
  };

  const imageHeight = {
    small: 'h-[190px] md:h-[220px]',
    normal: 'h-[220px] md:h-[250px]',
    large: 'h-[250px] md:h-[310px]',
  };

  const formatViews = (views: number) => {
    if (views >= 10000) {
      return `${(views / 10000).toFixed(1)}万`;
    }
    return views.toString();
  };

  return (
    <Link
      to={`/article/${comic.id}`}
      className={`${sizeClasses[size]} group cursor-pointer`}
    >
      <div className={`${imageHeight[size]} relative overflow-hidden rounded-lg mb-3`}>
        <img
          src={comic.cover}
          alt={comic.title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
          title={`${comic.title} - 韩国漫画网`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        {comic.isHot && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-[10px] font-medium bg-primary-500 text-white rounded-full">
            HOT
          </span>
        )}
        {comic.isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-[10px] font-medium bg-accent-500 text-background-50 rounded-full">
            NEW
          </span>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="text-[10px] text-white/90 bg-black/40 px-2 py-0.5 rounded-full">
            {comic.status}
          </span>
        </div>

        <div className="absolute top-2 right-2 flex items-center gap-1 bg-black/50 rounded-full px-1.5 py-0.5">
          <i className="ri-star-fill text-[10px] text-accent-500"></i>
          <span className="text-[10px] text-white font-medium">{comic.rating}</span>
        </div>
      </div>

      <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 mb-1 group-hover:text-primary-600 transition-colors">
        {comic.title}
      </h3>

      <div className="flex items-center gap-2 text-[11px] text-foreground-500">
        <span>{comic.author}</span>
        <span className="text-foreground-300">·</span>
        <span className="flex items-center gap-0.5">
          <i className="ri-eye-line text-[10px]"></i>
          {formatViews(comic.views)}
        </span>
      </div>
    </Link>
  );
}